import { gql } from 'urql';

export const NucleusDatasetList = gql`
  query NucleusDatasetList(
    $limit: Int
    $offset: Int
    $query: String
    $privacyType: [String]
    $tags: [String!]
  ) {
    viewer {
      __typename
      id
    }

    nucleusDatasets(
      offset: $offset
      limit: $limit
      query: $query
      privacyType: $privacyType
      tags: $tags
    ) {
      ...datasetListFields
    }
    nucleusDatasetsCount(query: $query, privacyType: $privacyType, tags: $tags)
  }

  query NucleusDatasetNameList($privacyType: [String]) {
    nucleusDatasets(privacyType: $privacyType) {
      __typename
      id
      name
    }
  }

  query NucleusAllDatasetNamesAndModelRuns($privacyType: [String]) {
    nucleusDatasets(privacyType: $privacyType) {
      ...datasetMinimumInfo
    }
  }

  query NucleusDatasetItemCountList($privacyType: [String]) {
    nucleusDatasets(privacyType: $privacyType) {
      __typename
      id
      itemCount
    }
  }

  query NucleusDatasetListLinkedProjects(
    $limit: Int
    $offset: Int
    $query: String
    $privacyType: [String]
    $tags: [String!]
  ) {
    nucleusDatasets(
      offset: $offset
      limit: $limit
      query: $query
      privacyType: $privacyType
      tags: $tags
    ) {
      __typename
      id
      linkedProjects {
        ...linkedProjectsFragment
      }
    }
  }

  query NucleusDatasetListByIds($ids: [ID!]!) {
    nucleusDatasetByIds(ids: $ids) {
      ...datasetListFields
    }
  }

  query NucleusDatasetItemCountListByIds($ids: [ID!]!) {
    nucleusDatasetByIds(ids: $ids) {
      __typename
      id
      itemCount
    }
  }

  query NucleusDatasetItemLinkedProjectByIds($ids: [ID!]!) {
    nucleusDatasetByIds(ids: $ids) {
      __typename
      id
      linkedProjects {
        ...linkedProjectsFragment
      }
    }
  }

  query NucleusDatasetTags {
    nucleusDatasetTags
  }

  fragment datasetMinimumInfo on NucleusDataset {
    __typename
    id
    name
    type
    is_public
    is_scene
    viewer_is_owner
    model_runs {
      ...modelRunMinimumInfo
    }
  }

  fragment modelRunMinimumInfo on NucleusModelRun {
    __typename
    id
    status
  }

  fragment datasetListFields on NucleusDataset {
    __typename
    id
    ...datasetListInfo
    user {
      __typename
      id
      firstName
      lastName
      email
    }
    cover_item {
      __typename
      id
      processed_image_url_grid
    }
    sliceCount
    tags
  }

  fragment datasetListInfo on NucleusDataset {
    __typename
    id
    name
    created_at
    delete_status
    is_public
    is_scene
    is_label_linked
    rapid_project_id
    self_serve_project_id
    invalid_task_types
    license_id
    viewer_is_owner
    pending_jobs {
      __typename
      id
      job_type
    }
  }

  fragment linkedProjectsFragment on NucleusDatasetLinkedProject {
    __typename
    projectId
    projectType
    taskType
    name
  }
`;

export * from './useNucleusDatasetList.generated';
